<template>
    <v-dialog v-model="open" max-width="600" persistent>
        <v-card class="background-2 round-card">
            <v-card-title class="pa-3">
                <p class="pl-2 pl-xl-3">Creazione DDT</p>
                <v-spacer></v-spacer>
            </v-card-title>                
            <v-divider></v-divider>
            <v-card-text class="pt-4 body-2">Vuoi creare un DDT per ogni elemento selezionato?</v-card-text>
            <v-card-text class="body-2">
                Elementi selezionati:  <span class="body-1 font-weight-medium">{{ allSelected ? allCount : selected.length }}</span>
            </v-card-text>
            <v-row class="mx-0 px-4">
                <v-col>
                    <gmh-date-picker
                        :validator="$validator"
                        v-model="model['date']"
                        label="Data documento*"
                        vv-name="Data documento"
                        validation="required"
                        :error-messages="errors.collect('Data documento')"
                    ></gmh-date-picker>
                </v-col>
            </v-row>
            <v-row class="mx-0 px-4">
                <v-col>
                    <gmh-date-picker
                        :validator="$validator"
                        v-model="model['month']"
                        type="month"
                        label="Mese di riferimento*"
                        vv-name="Mese di riferimento"
                        validation="required"
                        :error-messages="errors.collect('Mese di riferimento')"
                    ></gmh-date-picker>
                </v-col>
            </v-row>

            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="info" @click.native.stop="$emit('close')">Annulla
                </v-btn>
                <v-btn text color="primary" @click.native.stop="generateDdts()" :loading="loading">Procedi
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
	
	export default {
		name: 'generate-ddt',
		props: {
            open: Boolean,
            params: Object,
            selected: Array,
            modelDef: String,
            selectedIds: Array,
            // selezione "tutti" di Crud: il backend risolve l'insieme con select_all sui filtri della tabella
            allSelected: Boolean,
            allCount: Number,
            listFilters: Object,
		},
		data() {
            return {
                model: {'date': moment().format('YYYY-MM-DD')},
                loading: false,
                parse_doc: false,
			}
        },


        methods: {
                
            generateDdts() {
                let ids = this.selectedIds

                this.$validator.validateAll().then(result => {
                    
                    if (!result) {
                        return false
                    }
                    this.loading = true
                    this.axios.post(this.modelDef+'/generate-ddts', {ids: ids, model: this.model, select_all: this.allSelected, ...(this.allSelected ? this.listFilters : {})}).then(response => {
                        // get body data
                        let data = response.data
                        let snackmessage = ''
                        let snackcolor = ''
                        if(data.status == 'success'){
                            snackmessage = 'Generazione DDT avviata'
                            snackcolor = 'success'
                        } else{
                            snackmessage = data.message
                            snackcolor = 'warning'
                        }
                        this.$store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})

                        this.loading = false
                        this.$emit('close')

                    }, response => {
                        this.loading = false
                    })
                })
            }
        },

	}
</script>

